import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaCalculator, FaChartLine, FaBuilding, FaTimes } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Nav.css";
import logo from "../Assets/Images/BooksCompl.png";
import ContactForm from "../ContactForm/ContactFormModal.js";

const NavigationBar = () => {
  const [showDropdownServices, setShowDropdownServices] = useState(false);
  // const [showDropdownCompany, setShowDropdownCompany] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const servicesItems = [
    { label: "USA Company Formation", icon: FaCalculator, path: "/usa-company-formation" },
    { label: "Tax Return", icon: FaBuilding, path: "/tax-return" },
    { label: "Bookkeeping", icon: FaCalculator, path: "/bookkeeping" },
    { label: "CFO Advisory", icon: FaChartLine, path: "/cfo-advisory" },
    { label: "Zoho Advisory", icon: FaChartLine, path: "/zoho-advisory" },
  ];

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setShowContactForm(true);
  };

  const handleCloseContactForm = () => {
    setShowContactForm(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav 
        className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-2" 
        aria-label="Main Navigation"
        role="navigation"
      >
        <div className="container">
          <p className="visually-hidden" role="heading" aria-level="2">
            BooksComply - Main Navigation
          </p>
          <Link 
            className="navbar-brand" 
            to="/" 
            onClick={closeMobileMenu}
            aria-label="BooksComply Home"
          >
            <img 
              src={logo} 
              alt="BooksComply Logo" 
              className="img-fluid d-none d-md-block" 
              style={{ width: "250px" }}
              width="250"
              height="auto"
              loading="lazy"
            />
            <img 
              src={logo} 
              alt="BooksComply Logo" 
              className="img-fluid d-md-none" 
              style={{ width: "200px" }}
              width="200"
              height="auto"
              loading="lazy"
            />
          </Link>

          <button
            className="navbar-toggler ms-auto"
            type="button"
            onClick={toggleMobileMenu}
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle navigation"
          >
            {mobileMenuOpen ? (
              <FaTimes className="navbar-toggler-icon-x" />
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>

          <div 
            className={`collapse navbar-collapse ${mobileMenuOpen ? "show" : ""}`} 
            id="navbarContent"
            role="navigation"
            aria-label="Main Menu"
          >
            <button
              className="mobile-close-btn d-lg-none"
              onClick={closeMobileMenu}
              aria-label="Close main menu"
              aria-expanded={mobileMenuOpen}
              aria-controls="navbarContent"
            >
              <FaTimes aria-hidden="true" />
              <span className="visually-hidden">Close menu</span>
            </button>

            <ul className="navbar-nav ms-auto mb-2 mb-lg-0" role="menubar" aria-label="Main Menu">
              <li className="nav-item" role="none">
                <Link 
                  className="nav-link menu-link" 
                  to="/" 
                  role="menuitem"
                  aria-current={window.location.pathname === '/' ? 'page' : undefined}
                  onClick={(e) => {
                    closeMobileMenu();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  <span>Home</span>
                </Link>
              </li>
              
              <li 
                className="nav-item dropdown" 
                role="none"
                onMouseEnter={() => setShowDropdownServices(true)}
                onMouseLeave={() => setShowDropdownServices(false)}
              >
                <Link
                  className="nav-link dropdown-toggle menu-link"
                  to="#"
                  id="servicesDropdown"
                  role="menuitem"
                  aria-haspopup="true"
                  aria-expanded={showDropdownServices}
                  aria-controls="services-menu"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowDropdownServices(!showDropdownServices);
                  }}
                >
                  <span>Services</span>
                  <span className="visually-hidden">{showDropdownServices ? 'expanded' : 'collapsed'}</span>
                </Link>
                <ul
                  id="services-menu"
                  className={`dropdown-menu ${showDropdownServices ? "show" : ""}`}
                  role="menu"
                  aria-labelledby="servicesDropdown"
                  aria-hidden={!showDropdownServices}
                >
                  {servicesItems.map((item, index) => (
                    <li key={index} className="dropdown-item" role="none">
                      <Link 
                        className="text-dark text-decoration-none d-flex align-items-center" 
                        to={item.path} 
                        role="menuitem"
                        onClick={(e) => {
                          closeMobileMenu();
                          setShowDropdownServices(false);
                        }}
                        tabIndex={showDropdownServices ? 0 : -1}
                      >
                        <item.icon className="text-primary me-2" aria-hidden="true" />
                        <span>{item.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              
              <li className="nav-item" role="none">
                <Link 
                  className="nav-link menu-link" 
                  to="/pricing" 
                  role="menuitem"
                  aria-current={window.location.pathname === '/pricing' ? 'page' : undefined}
                  onClick={(e) => {
                    closeMobileMenu();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  <span>Pricing</span>
                </Link>
              </li>
              
              <li className="nav-item" role="none">
                <Link 
                  className="nav-link menu-link" 
                  to="/why-bookscomply" 
                  role="menuitem"
                  aria-current={window.location.pathname === '/why-bookscomply' ? 'page' : undefined}
                  onClick={(e) => {
                    closeMobileMenu();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  <span>Why BooksComply</span>
                </Link>
              </li>
              
              <li className="nav-item" role="none">
                <Link 
                  className="nav-link menu-link" 
                  to="/blog" 
                  role="menuitem"
                  aria-current={window.location.pathname.startsWith('/blog') ? 'page' : undefined}
                  onClick={(e) => {
                    closeMobileMenu();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  <span>Blog</span>
                </Link>
              </li>
            </ul>

            <div className="d-flex ms-lg-3 mt-2 mt-lg-0" role="navigation" aria-label="Account Actions">
              <button
                className="btn btn-warning-custom me-2"
                onClick={(e) => {
                  handleGetStartedClick(e);
                  closeMobileMenu();
                }}
                aria-label="Contact Us"
              >
                <span>Get in Touch</span>
              </button>
              <button
                className="btn btn-primary-custom"
                onClick={() => {
                  window.location.href = `${process.env.REACT_APP_REDIRECT_URL}/login`;
                  closeMobileMenu();
                }}
                aria-label="Login to your account"
              >
                <span>Login</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Contact Form Modal */}
      {showContactForm && (
        <ContactForm onClose={handleCloseContactForm} />
      )}
    </>
  );
};
export default NavigationBar;